
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join, substring } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { min } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { ofArray, map, head, isEmpty, empty, filter } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton, empty as empty_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofNullable, map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function PlaceholderInput(props) {
    let elems_3;
    const patternInput = useTranslation();
    const inputRef = reactApi.useRef(undefined);
    const patternInput_1 = reactApi.useState(false);
    const setSuggestionsOpen = patternInput_1[1];
    const isDisabled = props.ComponentState === "disabled";
    const currentFragment = () => {
        const matchValue = inputRef.current;
        if (matchValue == null) {
            return undefined;
        }
        else {
            const input = matchValue;
            const beforeCaret = substring(props.Value, 0, min(input.selectionStart, props.Value.length));
            const openIndex = beforeCaret.lastIndexOf("{") | 0;
            if ((openIndex >= 0) && !(substring(beforeCaret, openIndex).indexOf("}") >= 0)) {
                return [openIndex, substring(beforeCaret, openIndex + 1)];
            }
            else {
                return undefined;
            }
        }
    };
    const insertPlaceholder = (placeholder) => {
        const token = ("{" + placeholder) + "}";
        const matchValue_1 = currentFragment();
        if (matchValue_1 == null) {
            const matchValue_2 = inputRef.current;
            if (matchValue_2 == null) {
                props.OnChange((props.Value === "") ? token : ((props.Value + " ") + token));
            }
            else {
                const input_1 = matchValue_2;
                const caret_2 = input_1.selectionStart | 0;
                const before_1 = substring(props.Value, 0, min(caret_2, props.Value.length));
                const after_1 = substring(props.Value, min(caret_2, props.Value.length));
                props.OnChange(((before_1 + (((before_1 === "") ? true : before_1.endsWith(" ")) ? "" : " ")) + token) + after_1);
            }
        }
        else {
            const openIndex_1 = matchValue_1[0] | 0;
            const fragment = matchValue_1[1];
            const caret_1 = ((openIndex_1 + 1) + fragment.length) | 0;
            props.OnChange((substring(props.Value, 0, openIndex_1) + token) + substring(props.Value, min(caret_1, props.Value.length)));
        }
        setSuggestionsOpen(false);
    };
    let suggestions;
    const matchValue_3 = currentFragment();
    let matchResult;
    if (patternInput_1[0]) {
        if (matchValue_3 != null) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const fragment_1 = matchValue_3[1];
            const search = fragment_1.toLowerCase();
            suggestions = filter((placeholder_1) => {
                if (placeholder_1.Key.startsWith(search)) {
                    return true;
                }
                else {
                    return placeholder_1.Label.toLowerCase().startsWith(search);
                }
            }, props.Placeholders);
            break;
        }
        default:
            suggestions = empty();
    }
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-1", "relative"])], (elems_3 = toList(delay(() => {
        let matchValue_5, label;
        return append((matchValue_5 = props.Label, (matchValue_5 == null) ? (empty_1()) : ((label = matchValue_5, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => append(singleton(reactElement("input", {
            ref: inputRef,
            "data-test-id": concat(props.TestId, ..."-input"),
            type: "text",
            value: props.Value,
            disabled: isDisabled,
            className: join(" ", ["bg-white", "border", "focus:outline-none", "focus:border-primary", "rounded-lg", "h-10", "w-full", "px-3", "text-base", "border-[#B6BECB]", "disabled:bg-background", "disabled:text-text-muted", "disabled:cursor-not-allowed"]),
            onChange: (ev) => {
                const value_16 = ev.target.value;
                props.OnChange(value_16);
                setSuggestionsOpen(value_16.indexOf("{") >= 0);
            },
            onKeyDown: (event) => {
                if (event.key === "Escape") {
                    setSuggestionsOpen(false);
                }
                else if ((event.key === "Enter") && !isEmpty(suggestions)) {
                    event.preventDefault();
                    insertPlaceholder(head(suggestions).Key);
                }
            },
            onBlur: (_arg) => {
                window.setTimeout((_arg_1) => {
                    setSuggestionsOpen(false);
                }, 150);
            },
        })), delay(() => {
            let elems_1;
            return append(!isEmpty(suggestions) ? singleton(reactElement("ul", createObj(ofArray([["data-test-id", concat(props.TestId, ..."-suggestions")], ["className", join(" ", ["absolute", "top-full", "left-0", "z-20", "mt-1", "max-h-48", "w-full", "overflow-auto", "rounded-lg", "border", "border-[#B6BECB]", "bg-white", "shadow-lg"])], (elems_1 = toList(delay(() => map((placeholder_2) => {
                let elems;
                return reactElement("li", createObj(ofArray([["className", join(" ", ["flex", "cursor-pointer", "items-center", "gap-2", "px-3", "py-1.5", "text-sm", "hover:bg-background"])], ["onMouseDown", (event_1) => {
                    event_1.preventDefault();
                    insertPlaceholder(placeholder_2.Key);
                }], (elems = [reactElement("span", {
                    className: join(" ", ["font-mono", "text-xs"]),
                    children: ("{" + placeholder_2.Key) + "}",
                }), reactElement("span", {
                    className: join(" ", ["text-text-muted"]),
                    children: placeholder_2.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
            }, suggestions))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1(), delay(() => {
                let elems_2;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-1.5", "mt-1"])], (elems_2 = toList(delay(() => map((placeholder_3) => reactElement("button", {
                    type: "button",
                    "data-test-id": concat(props.TestId, "-chip-", ...placeholder_3.Key),
                    disabled: isDisabled,
                    title: ("{" + placeholder_3.Key) + "}",
                    className: join(" ", ["flex", "h-6", "items-center", "rounded-xl", "bg-background", "px-2.5", "text-xs", "text-black", "transition-colors", "hover:bg-primary", "hover:text-white", "disabled:cursor-not-allowed", "disabled:opacity-50"]),
                    onClick: (_arg_2) => {
                        insertPlaceholder(placeholder_3.Key);
                    },
                    children: placeholder_3.Label,
                }), props.Placeholders))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function PlaceholderTextArea(props) {
    let elems_1;
    const textAreaRef = reactApi.useRef(undefined);
    const isDisabled = props.ComponentState === "disabled";
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_1 = toList(delay(() => {
        let matchValue_1, label;
        return append((matchValue_1 = props.Label, (matchValue_1 == null) ? (empty_1()) : ((label = matchValue_1, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => append(singleton(reactElement("textarea", {
            ref: (element) => {
                textAreaRef.current = map_1((value_7) => value_7, ofNullable(element));
            },
            "data-test-id": concat(props.TestId, ..."-input"),
            value: props.Value,
            disabled: isDisabled,
            rows: 5,
            className: join(" ", ["bg-white", "border", "focus:outline-none", "focus:border-primary", "rounded-lg", "w-full", "px-3", "py-2", "text-base", "border-[#B6BECB]", "disabled:bg-background", "disabled:text-text-muted", "disabled:cursor-not-allowed"]),
            onChange: (ev) => {
                props.OnChange(ev.target.value);
            },
        })), delay(() => {
            let elems;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-1.5", "mt-1"])], (elems = toList(delay(() => map((placeholder_1) => reactElement("button", {
                type: "button",
                "data-test-id": concat(props.TestId, "-chip-", ...placeholder_1.Key),
                disabled: isDisabled,
                title: ("{" + placeholder_1.Key) + "}",
                className: join(" ", ["flex", "h-6", "items-center", "rounded-xl", "bg-background", "px-2.5", "text-xs", "text-black", "transition-colors", "hover:bg-primary", "hover:text-white", "disabled:cursor-not-allowed", "disabled:opacity-50"]),
                onClick: (_arg) => {
                    const token = ("{" + placeholder_1.Key) + "}";
                    const matchValue = textAreaRef.current;
                    if (matchValue == null) {
                        props.OnChange((props.Value === "") ? token : ((props.Value + " ") + token));
                    }
                    else {
                        const textArea = matchValue;
                        const caret = textArea.selectionStart | 0;
                        const before = substring(props.Value, 0, min(caret, props.Value.length));
                        const after = substring(props.Value, min(caret, props.Value.length));
                        props.OnChange(((before + ((((before === "") ? true : before.endsWith(" ")) ? true : before.endsWith("\n")) ? "" : " ")) + token) + after);
                    }
                },
                children: placeholder_1.Label,
            }), props.Placeholders))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

